import { render } from "./TestimonialsSliderItem.vue?vue&type=template&id=4e9abec4"
import script from "./TestimonialsSliderItem.vue?vue&type=script&lang=js"
export * from "./TestimonialsSliderItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__